<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">View</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns" v-if="data">
          <div class="column">
            <b-field label="Email">
              <b-input v-model="data.email" :disabled="isDisable" />
            </b-field>

            <b-field label="Uploaded by">
              <b-input v-model="data.user" :disabled="isDisable" />
            </b-field>

            <b-field label="Customer Name">
              <b-input v-model="data.customer_name" :disabled="isDisable" />
            </b-field>

            <b-field label="Country">
              <b-input v-model="data.country" :disabled="isDisable" />
            </b-field>

            <b-field label="Period">
              <b-input v-model="data.period" :disabled="isDisable" />
            </b-field>

            <b-field label="Stream">
              <b-input v-model="data.stream" :disabled="isDisable" />
            </b-field>

            <b-field label="Date of Upload">
              <b-input v-model="data.date_of_upload" :disabled="isDisable" />
            </b-field>
            <b-field label="Documents">
              <div class="tags" :disabled="isDisable" v-if="!isViewOnly">
                <span
                  v-for="(file, index) in data.document_uploaded"
                  :key="index"
                  class="tag"
                  @click.prevent="downloadContent(file)"
                  ><a href="#"
                    >{{ file.document }}<i class="mdi mdi-download"></i
                  ></a>
                </span>
              </div>
              <div class="tags" :disabled="isDisable" v-else>
                <span
                  v-for="(file, index) in data.document_uploaded"
                  :key="index"
                  class="tag"
                  disabled="true"
                >
                  <a class="disable-tag-view-only">{{ file.document }}</a>
                </span>
              </div>
            </b-field>
            <b-field label="Comment">
              <b-input
                type="textarea"
                v-model="data.comments"
                :disabled="isDisable"
              />
            </b-field>
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
import CustomerUploadService from "../../services/CustomerUploadService";
export default {
  name: "uploadedData",
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isDisable: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(["userHasPermission", "userGroups"]),
    isViewOnly() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    downloadContent(file) {
      // Pass the raw filename - the service will handle URL encoding
      const fileName = file.document;
      try {
        this.customerUploadService.exportCustomerUpload(
          this.data.id,
          fileName,
          this.data.customer_id
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    }
  },
  data() {
    return {
      isModalActive: false,
      customerUploadService: new CustomerUploadService()
    };
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
